// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import appInfo from '../../../configs/app-info';

import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import {
    Divider,
    IconButton,
    Tooltip,
    Autocomplete,
    Fab
} from '@mui/material'
import { useNavigate } from "react-router-dom";
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../components/icon';
import apiUrl from '../../../configs/constant';
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto';

import moment from 'moment'
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'

import { getDoctag } from '../../../api/helper';

export default function Index() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token

    const cabang = JSON.parse(localStorage.getItem('cabang')!)

    // ** State
    const [tabs, setTabs] = useState<string>("0")

    const [tglAwal, setTglAwal] = useState<string>(moment().subtract(3, 'months').startOf('month').format('YYYY-MM-DD'))
    const [tglAkhir, setTglAkhir] = useState<string>(moment().endOf('month').format('YYYY-MM-DD'))
    const [doctag, setDoctag] = useState<any>(null)
    const [valDoctag, setValDoctag] = useState<any>(null)
    const [listDoctag, setListDoctag] = useState<any[]>([])

    const [listData, setListData] = useState<any[]>([])

    useEffect(() => {
        getBelumUsage()
    }, [])

    const navigate = useNavigate();

    const getSudahUsage = () => {
        setListData([])
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const url = apiUrl.apiUrl + '/mm/usage-kain/list-sudah-usage'

        axios
            .get(url, {
                params: {
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getBelumUsage = () => {
        setListData([])
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const url = apiUrl.apiUrl + '/mm/usage-kain/list-belum-usage'

        axios
            .get(url, {
                params: {
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const restockData = () => {
    }

    const handleChangeTabs = (event: SyntheticEvent, newValue: string) => {
        setTabs(newValue)
    }

    const ActionButtons = ({ row, onNavigate }: {
        row: any;
        onNavigate: (id: string) => void
    }) => {
        const actions = [
            {
                title: "Kerjakan",
                icon: "mdi:pencil",
                color: "primary",
                onClick: () => onNavigate(row.id)
            }
        ];

        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Button
                            variant='contained'
                            color='primary'
                            startIcon={<Icon icon={action.icon} />}
                            onClick={action.onClick}
                        >
                            {action.title}
                        </Button>
                    </Box>
                ))}
            </Box>
        );
    };
    const ActionButtonsSudahUsage = ({ row, onNavigate }: {
        row: any;
        onNavigate: (id: string) => void
    }) => {
        const actions = [
            {
                title: "Lihat",
                icon: "mdi:search",
                color: "primary",
                onClick: () => onNavigate(row.id)
            }
        ];

        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Button
                            variant='contained'
                            color='primary'
                            startIcon={<Icon icon={action.icon} />}
                            onClick={action.onClick}
                        >
                            {action.title}
                        </Button>
                    </Box>
                ))}
            </Box>
        );
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 160,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onNavigate={(id) => navigate('/mm/usage-kain/detail/' + id)}
                />
            ),
        },
    ];

    const actionSudahUsage = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 130,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtonsSudahUsage
                    row={row}
                    onNavigate={(id) => navigate('/mm/usage-kain/detail/' + id)}
                />
            ),
        },
    ];

    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <CardHeader title='USAGE KAIN' />
                        </Box>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mr: 2 }}>
                        </Box>
                    </Box>
                    <Divider />
                    <TabContext value={tabs}>
                        <TabList
                            scrollButtons
                            variant='scrollable'
                            onChange={handleChangeTabs}
                            aria-label='forced scroll tabs example'
                        >
                            <Tab value='0' label='Belum Usage' onClick={getBelumUsage} />
                            <Tab value='1' label='Sudah Usage' onClick={getSudahUsage} />
                        </TabList>
                        <TabPanel value='0'>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                                <Button
                                    sx={{ marginRight: 3 }}
                                    variant='contained'
                                    color='success'
                                    startIcon={<Icon icon='mdi:table-refresh' />}
                                    onClick={restockData}
                                >
                                    RESTOCK
                                </Button>
                                <Button
                                    sx={{ marginRight: 3 }}
                                    variant='contained'
                                    color='primary'
                                    startIcon={<Icon icon='mdi:refresh' />}
                                    onClick={getBelumUsage}
                                >
                                    PERBARUI DATA
                                </Button>
                            </Box>
                            <MsiDatagrid array={listData} actions={actionData} />
                        </TabPanel>
                        <TabPanel value='1'>
                            <MsiDatagrid array={listData} actions={actionSudahUsage} />
                        </TabPanel>
                    </TabContext>
                </div>
            </Grid>
        </Grid>
    )
}
